export default class CreateOtherActivityCtrl {

  constructor ($scope, WorkPlanSrv, $mdDialog, $stateParams, $cookies, GlobalConfig, GlobalSrv) {
    var createActivityVm = this
    const currentUser = $cookies.getObject('currentUser')
    createActivityVm.nameActivityModal = ''
    createActivityVm.hrefActivityModal = ''
    createActivityVm.createOrEdit = ''
    createActivityVm.idWorkPlan = currentUser.workplanId
    createActivityVm.idTeacher = currentUser.teacherId
    createActivityVm.workplanTeacherActivityId = $stateParams.activityId
    const SEARCH_PARAMS = {
      teacherId: createActivityVm.idTeacher,
      workplanId: createActivityVm.idWorkPlan,
      workplanTeacherActivityId: createActivityVm.workplanTeacherActivityId,
      name: currentUser.name
    }
    createActivityVm.comboActivities = []
    createActivityVm.activityItem = []
    createActivityVm.itemActivityRequired = []
    createActivityVm.isEditing = ($stateParams.activityId) ? true : false
    createActivityVm.rangeType = 1

    createActivityVm.periodsArray = []
    createActivityVm.typePeriod = []
    createActivityVm.isTouchedPeriods = false
    createActivityVm.selectedTypePeriod = {}
    createActivityVm.initialDate = null
    createActivityVm.finalDate = null
    createActivityVm.minStartDate = new Date()
    createActivityVm.minEndDate = new Date()
    createActivityVm.isFeedback = currentUser.isFeedback
    createActivityVm.dt_start = $cookies.get('wp_start')
    createActivityVm.dt_end = $cookies.get('wp_end')

    createActivityVm.funSelectedPeriod = funSelectedPeriod
    createActivityVm.addActivity = addActivity
    createActivityVm.validateCheklistPeriods = validateCheklistPeriods

    createActivityVm.startDateChange = startDateChange

    createActivityVm.hasError = hasError
    createActivityVm.showErrorMessages = showErrorMessages
    createActivityVm.validateForm = validateForm
    createActivityVm.close = close
    createActivityVm.hours = 0
    createActivityVm.updateRangeType = (val) => {
      createActivityVm.rangeType = val
      createActivityVm.periodsArray = []
      createActivityVm.startDate = null
      createActivityVm.endDate = null
    }
    createActivityVm.updateRangeData = (val) => {
      createActivityVm.periodsArray = val['periods']
      createActivityVm.initialDate = val['dates'][0]
      createActivityVm.finalDate = val['dates'][1]
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      if (input) {
        return input.$dirty || input.$touched
      } else {
        return false
      }
    }

    function validateForm (form) {
      return form.$invalid ||
             createActivityVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createActivityVm.rangeType == 1 ? createActivityVm.periodsArray.length < 1 : false)
    }

    function startDateChange () {
      let m = moment(createActivityVm.initialDate)
      createActivityVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    activate()

    function activate () {
      if (createActivityVm.isEditing) {
        createActivityVm.createOrEdit = 'Editar '
      } else {
        createActivityVm.createOrEdit = 'Agregar '
      }
      getDaysAndPeriodsData()
      getActivitiesCombo()

      if (createActivityVm.isEditing) {
        getActivity()
      }
    }

    function getActivityNameFromCombo () {
      for (var i = 0; i < createActivityVm.comboActivities.length; i++) {
        var row = createActivityVm.comboActivities[i]
        if (row.activityTypeCode == createActivityVm.activityCode) {
          return createActivityVm.comboActivities[i].activityTypeName
        }
      }
    }

    function addActivity (sw, isExecution) {
      createActivityVm.isSaveButtonDisabled = true
      createActivityVm.hrefActivityModal = sw
      let origin = 1
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var activity = {
        idTeacher: createActivityVm.idTeacher,
        idWorkPlan: createActivityVm.idWorkPlan,
        activityHoursPlaned: createActivityVm.hours,
        activityCode: createActivityVm.activityCode,
        activityDetail: createActivityVm.detail,
        periodType: createActivityVm.rangeType,
        origin: origin,
        isFeedbackActivity: createActivityVm.isFeedback
      }

      if (parseInt(createActivityVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createActivityVm.periodsArray) {
          var temp = {
            periodId: createActivityVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        activity.periods = arrayPeriod
      } else {
        activity.initialDate = new Date(createActivityVm.initialDate)
        activity.finalDate = new Date(createActivityVm.finalDate)
      }

      if (createActivityVm.isEditing) {
        activity.workplanTeacherActivityId = createActivityVm.workplanTeacherActivityId
      }

      addOrEditActivity(activity)
    }

    function addOrEditActivity (activity) {
      WorkPlanSrv.addOtherActivityAM.add(activity).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          showModalSucces()
        } else {
          createActivityVm.isSaveButtonDisabled = false
          showModalFailure()
        }
      }, function (data) {
        console.log(data)
      })
    }

    function showModalSucces () {
      let texts = GlobalConfig.appTexts
      let activityName = getActivityNameFromCombo()
      let hrefActivity = createActivityVm.hrefActivityModal
      let actionEditOrCreate = texts.createDialog
      let textCreateOrEdit = texts.saved
      if (createActivityVm.isEditing) {
        actionEditOrCreate = texts.editDialog
        textCreateOrEdit = texts.modified
      }
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', '$state', function($scope, $mdDialog, $state) {
          let ctrlModal = this
          ctrlModal.activityModal = hrefActivity
          ctrlModal.actionEditOrCreateModal = actionEditOrCreate
          ctrlModal.textCreateOrEdit = textCreateOrEdit
          ctrlModal.nameActivityModal = activityName
          ctrlModal.close = function () {
            $mdDialog.hide()
            isAllActivityItemRequired()
            if ($state.current.name === 'workplan.createOtherActivity') {
              $state.go('workplan.otherActivities')
            } else {
              $state.reload()
            }
          }
        }],
        controllerAs: 'ctrlModal',
        template: require('./successActivityModal.html'),
        clickOutsideToClose: false
      })
    }

    function showModalFailure () {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          var failureDialogCtlVm = this
          failureDialogCtlVm.close = function () {
            $mdDialog.hide()
          }
        }],
        template: require('./failureActivityModal.html'),
        controllerAs: 'failureDialogCtlVm',
        clickOutsideToClose: true
      })
    }

    function getDaysAndPeriodsData () {
      WorkPlanSrv.getDataForSchedule.get(SEARCH_PARAMS).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createActivityVm.typePeriod = dataReturn.periods
        } else {
        }
      }, function (data) {
        console.log(data)
      })
    }

    function getActivitiesCombo () {
      let requestHeader = {
        listTypeId: GlobalConfig.typeListId.academicManagement,
        listId: GlobalConfig.listId.academicManagementotherActivities
      }
      WorkPlanSrv.getActivitiesCombo.getList(requestHeader).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createActivityVm.comboActivities = dataReturn.data
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function getActivity () {
      WorkPlanSrv.getOtherActivityItemAM.get(SEARCH_PARAMS).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          console.log(dataReturn.data[0])
          setValues(dataReturn.data[0])
        } else {
        }
      }, function (data) {
        console.log(data)
      })
    }

    function setValues (activity) {
      createActivityVm.activityCode = activity.activityCode
      createActivityVm.nameActivity = activity.activityName

      createActivityVm.rangeType = activity.periodType
      createActivityVm.hours = activity.activityHoursPlaned
      createActivityVm.detail = activity.description

      createActivityVm.dt_start = moment(activity.startDate, 'YYYY-MM-DD').toDate()
      createActivityVm.dt_end = moment(activity.endDate, 'YYYY-MM-DD').toDate()

      createActivityVm.periodsArray = []
      createActivityVm.selectedTypePeriod = {}

      if (createActivityVm.rangeType == 1) {
        var splits = activity.periodId.split(',')
        createActivityVm.initialDate = null
        createActivityVm.finalDate = null
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createActivityVm.periodsArray.push(parseInt(valor))
          createActivityVm.selectedTypePeriod[valor] = true
        }
      }

      if (activity.startDate) {
        var startDateNew = moment(activity.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createActivityVm.minStartDate = moment(activity.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createActivityVm.isEditing = true
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createActivityVm.periodsArray.includes(period.periodId)) {
          createActivityVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createActivityVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createActivityVm.periodsArray.splice(index, 1)
        }
      }
      createActivityVm.isTouchedPeriods = true
    }

    function close () {
      $mdDialog.hide()
    }

    function isAllActivityItemRequired () {
      let header = {
        teacherId: currentUser.teacherId,
        workplanId: currentUser.workplanId,
        listId: GlobalConfig.listId.academicManagementotherActivities
      }

      WorkPlanSrv.getItemRequiredOtherActivities.getList(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createActivityVm.itemActivityRequired = dataReturn.otherActivities
          if (createActivityVm.itemActivityRequired.length > 0) {
            showModalItemRequired()
          }
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function showModalItemRequired () {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          $scope.itemRequired = createActivityVm.itemActivityRequired
          $scope.hrefActivityModal = createActivityVm.hrefActivityModal
          $scope.close = function () {
            $mdDialog.hide()
          }
        }],
        template: require('./activityItemRequiredModal.html'),
        clickOutsideToClose: false
      })
    }
  }// FIN DEL CONSTRUCTOR

  rbPlanifications (bool) {
    if (bool) {
      this.initialDate = null
      this.finalDate = null
    } else {
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.initialDate = null
      this.finalDate = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) { event.preventDefault() }
    return
  }
}

CreateOtherActivityCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/otherActivities/createOtherActivity/createOtherActivityCtrl.js